<template>
  <div class="container-table-striped w-100 mt-4">
    <div class="table-hover">
      <table class="table content-table-striped table-h">
        <thead>
          <tr class="row global-thead-dark thead-property">
            <th class="col-4 text-left bold">
              Cuestionario
            </th>
            <th class="col-4 text-left bold">
              Estatus
            </th>
            <th class="col-4 text-left" />
          </tr>
        </thead>
        <tbody>
          <tr class="row">
            <td class="col-md-4 text-left">
              <b class="ml-3">
                <span>{{ this.questionaryNumber }}</span>
              </b>
            </td>
            <td class="col-md-4 text-left">
              <div class="ml-3">
                <ServiceStatusBadge
                  :title="this.questionnaireStatus"
                  :success="showTransportType"
                />
              </div>
            </td>
            <td class="col-md-4 text-right">
              <div v-if="showTransportType">
                <button
                  class="btn btn-dropdown-actions dropdown-toggle pt-1 mr-4"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Acciones
                </button>
                <div class="dropdown-menu dropdown-menu-right pb-0">
                  <a class="drop-item" @click="onEditClick">
                    <i class="fas fa-edit text-green pr-2" />
                    <span>Editar</span>
                  </a>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td v-if="showTransportType" colspan="3">
              <div class="box-white">
                <span class="box-white-title">
                  Detalle de transportación del estudiante:
                </span>

                <div class="mt-4">
                  <!-- Set tranport type component -->
                  <div>
                    <TransportNoDefined
                      v-if="isNotDefined"
                      @onTransportTypeChange="onTransportTypeChange"
                    />
                    <TransportRegular
                      v-if="
                        isRegular &&
                          departureList.length > 0 &&
                          placeList.length > 0
                      "
                      v-model="value"
                      :is-from-aee="isFromAee"
                      :departure-list="filterDepartureList"
                      :place-list="filterPlaceList"
                      :transport-disabled="questionaryDisabled"
                      :municipality-list="municipalityList"
                      :disabled-departure="disabledDeparture"
                      :disabled-place="disabledPlace"
                      @onTransportTypeChange="onTransportTypeChange"
                    />
                    <TransportCarrier
                      v-if="showTransportCarrier"
                      v-model="value"
                      :is-from-aee="isFromAee"
                      :departure-list="filterDepartureList"
                      :place-list="filterPlaceList"
                      :special-equipment-list="specialEquipment"
                      :transport-disabled="questionaryDisabled"
                      :allowed-transport-options="transportOptionsAllowed"
                      :municipality-list="municipalityList"
                      :disabled-departure="disabledDeparture"
                      :disabled-place="disabledPlace"
                      @onTransportTypeChange="onTransportTypeChange"
                    />
                    <TransportScholarship
                      v-if="
                        isScholarship &&
                          departureList.length > 0 &&
                          placeList.length > 0
                      "
                      v-model="value"
                      :is-from-aee="isFromAee"
                      :departure-list="filterDepartureList"
                      :place-list="filterPlaceList"
                      :municipality-list="municipalityList"
                      :disabled-departure="disabledDeparture"
                      :disabled-place="disabledPlace"
                      :current-academic-year="peiYear"
                      :special-equipment-list="specialEquipment"
                      :transport-disabled="questionaryDisabled"
                      :allowed-transport-options="transportOptionsAllowed"
                      @onTransportTypeChange="onTransportTypeChange"
                    />

                    <div v-if="this.localTransportType == '-1'">
                      <ServiceWarningBox
                        :title="
                          'Si el impedimento o condiciones específicas del estudiante no se adaptan a las alternativas ofrecidas en esta guía, deberá realizar una consulta al facilitador docente de su municipio o distrito.'
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td v-show="!showTransportType" colspan="3" class="accordion-box">
              <Accordion v-show="isValid" :id="'questionnaireAccordion'">
                <AccordionItem
                  v-for="(section, index) in currentSections"
                  :id="'seccion' + (index + 1)"
                  :key="'section' + index"
                  :title="'Sección ' + (index + 1)"
                >
                  <div v-show="section.questions.length > 0" slot="content">
                    <WizardQuestion
                      v-for="question in section.questions"
                      :id="`qQuestions-${index}`"
                      :key="question.id"
                      :ref="'question_' + question.id"
                      :description="question.text"
                      :answer-control-type="1"
                      :display-number="'seccion' + (index + 1)"
                      :number="question.id"
                      :hide-icon-box="false"
                      :on-change="setSelectedAnswer"
                      :is-disabled="questionaryDisabled || question.disabled"
                      :warning-message="question.warningMessage ?? null"
                      :hasAttachedWarning="question.warningMessage ?? false"
                      :default-option-value-selected="
                        question.defaultOptionValueSelected
                      "
                      class="custom-item"
                      @onMounted="onMounted"
                    />
                  </div>
                </AccordionItem>
              </Accordion>
              <div
                v-if="isValid && !questionaryDisabled"
                class="float-right mr-n4 mt-4"
              >
                <button
                  id="btnSaveQuestionnaire"
                  type="button"
                  class="btn btn-green"
                  @click="onSaveClick"
                >
                  <span>Guardar</span>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';
import {
  ServiceStatusBadge,
  ServiceWarningBox,
} from '@/components/pei/service/components';
import { Accordion, AccordionItem } from '@/components/pei/shared/accordion';
import WizardQuestion from '@/components/pei/WizardQuestion';
import {
  TransportNoDefined,
  TransportRegular,
  TransportCarrier,
  TransportScholarship,
} from '@/components/pei/service/components/transport-detail';
import alert from '@/mixin/alert.mixin';
import store from '@/store/index';
import transportTypes from '@/utils/constants/pei/transportTypes.js';
import departurePlaces from '@/utils/constants/pei/transportationDeparturesPlaces';
import peiAnalysisServices from '@/utils/constants/pei/peiAnalysisService.js';
import locationTypes from '@/utils/constants/LocationTypes';
import schoolTypes from '@/utils/constants/student/schoolTypes.js';

const ALLOW_EDITING_SCHOOL_TYPES = [
  schoolTypes.HeadStart,
  schoolTypes.Home,
  schoolTypes.CareCenter,
];

export default {
  name: 'ServiceQuestionnaire',
  data() {
    return {
      departureList: [],
      placeList: [],
      municipalityList: [],
      specialEquipment: [],
      startDate: null,
      endDate: null,
      peiYear: null,
      localTransportType: '261',
      model: {},
    };
  },
  computed: {
    showTransportCarrier() {
      return (
        this.isCarrier &&
        this.departureList.length > 0 &&
        this.placeList.length > 0 &&
        this.specialEquipment.length > 0
      );
    },
    currentSections() {
      return this.questions.filter((section, index) =>
        this.isVisibleSection(index + 1, section.questions)
      );
    },
    isAllAnsweredNo() {
      if (this.questions.length == this.currentSections.length) {
        let result = this.currentSections.every(
          (section) => !this.hasAnsweredInSection(section.id, 1)
        );
        return result;
      }
      return false;
    },
    transportOptionsAllowed() {
      if (!this.isTherapyService) {
        let questionToValidate = [212, 213];

        let needFilter = questionToValidate.some((id) =>
          this.hasQuestionWithValue(id, 1)
        );

        if (needFilter) return ['140', '141'];
      }
      return null;
    },
    seccion1() {
      return this.getSeccionQuestions(0);
    },
    seccion2() {
      return this.getSeccionQuestions(1);
    },
    seccion3() {
      return this.getSeccionQuestions(2);
    },
    seccion4() {
      return this.getSeccionQuestions(3);
    },
    indexForTherapySevice() {
      let hasAnyAnsweredYes = this.hasAnsweredInSection(30, 1);

      if (!hasAnyAnsweredYes) {
        let hasAllAnsweredNo = this.hasAllAnsweredInSection(30, 2);

        if (!hasAllAnsweredNo) {
          return 1;
        }

        return 2;
      }
      return 1;
    },
    indexForEducativeSevice() {
      let hasAnyAnsweredYes = this.hasAnsweredInSection(30, 1);

      if (!hasAnyAnsweredYes) {
        if (this.hasAnsweredInSection(31, 2)) {
          return 3;
        }

        let hasAnyAnsweredNo = this.hasAllAnsweredInSection(30, 2);

        if (!hasAnyAnsweredNo) {
          return 1;
        }

        return 2;
      }
      return 1;
    },
    sectionIndex() {
      if (this.isTherapyService) return this.indexForTherapySevice;

      return this.indexForEducativeSevice;
    },
    isEducativeService() {
      return this.peiServiceTypeId == peiAnalysisServices.Educativo;
    },
    filterDepartureList() {
      return this.isTherapyService
        ? this.departureList.filter(
            (x) =>
              x.id == departurePlaces.home || x.id == departurePlaces.school
          )
        : this.departureList;
    },
    filterPlaceList() {
      return this.isTherapyService
        ? this.placeList.filter(
            (x) =>
              x.id == departurePlaces.csse ||
              x.id == departurePlaces.providerOffice ||
              x.id == departurePlaces.school
          )
        : this.placeList;
    },
    isNotDefined() {
      return this.localTransportType == transportTypes.NO_ES_NECESARIO;
    },
    isRegular() {
      return this.localTransportType == transportTypes.REGULAR;
    },
    isScholarship() {
      return this.localTransportType == transportTypes.BECA;
    },
    isCarrier() {
      return this.localTransportType == transportTypes.PORTEADOR;
    },
    disabledDeparture() {
      const schoolTypeId = get(this.value, 'departure.schoolTypeId', 0);
      const allowEditingForSchoolTypes =
        !ALLOW_EDITING_SCHOOL_TYPES.includes(schoolTypeId) ||
        !store.getters.HasPermission(
          'pei.tab8.services.transportation.address.edit'
        );
      return (
        this.value.departureCode == null ||
        this.value.departureCode == locationTypes.CSEE ||
        (this.value.departureCode == locationTypes.Escuela &&
          allowEditingForSchoolTypes)
      );
    },
    disabledPlace() {
      const schoolTypeId = get(this.value, 'place.schoolTypeId', 0);
      const allowEditingForSchoolTypes =
        !ALLOW_EDITING_SCHOOL_TYPES.includes(schoolTypeId) ||
        !store.getters.HasPermission(
          'pei.tab8.services.transportation.address.edit'
        );
      return (
        this.value.placeCode == null ||
        this.value.placeCode == locationTypes.CSEE ||
        (this.value.placeCode == locationTypes.Escuela &&
          allowEditingForSchoolTypes)
      );
    },
  },
  watch: {
    async transportType(newValue) {
      this.localTransportType = newValue;
    },
    currentSections() {
      this.removeValuesOfHiddenSections();
    },
  },
  props: {
    questions: {
      type: Array,
      required: true,
    },
    questionaryId: {
      type: Number,
      required: true,
    },
    isValid: {
      type: Boolean,
      default: () => true,
    },
    isFromAee: {
      type: Boolean,
      default: () => false,
    },
    questionnaireStatus: {
      type: String,
      required: true,
    },
    transportType: {
      type: String,
      default: () => '1',
    },
    showTransportType: {
      type: Boolean,
      default: () => false,
    },
    questionaryNumber: {
      type: String,
      default: '',
    },
    questionaryDisabled: {
      type: Boolean,
      default: () => false,
    },
    isTherapyService: {
      type: Boolean,
      default: () => false,
    },
    peiServiceTypeId: {
      type: Number,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({
        departureCode: 0,
        placeCode: 0,
        specialEquipmentCode: 0,
        acompanyCode: '',
        mileage: 0,
        startDate: '',
        endDate: '',
        peiAnalysisServiceCode: 0,
        justification: '',
        departure: {
          addressLine1: '',
          addressLine2: '',
          municipalityId: '',
          phone: '',
          state: '',
          zipCode: '',
        },
        place: {
          addressLine1: '',
          addressLine2: '',
          municipalityId: '',
          phone: '',
          state: '',
          zipCode: '',
        },
      }),
    },
  },
  methods: {
    hasQuestionWithValue(questionId, answerId) {
      return this.currentSections.some((section) =>
        section.questions.some(
          (q) =>
            q.id == questionId &&
            q.answers.some((a) => a.isSelected && a.id == answerId)
        )
      );
    },
    onMounted(question) {
      if (question.number == 207) {
        this.validateQuestion207();
      }
    },
    removeValuesOfHiddenSections() {
      let hiddenSections = this.questions.filter(
        (a) => !this.currentSections.some((s) => s.id == a.id)
      );
      hiddenSections.forEach((element) => {
        element.questions.forEach((question) => {
          question.answers.forEach((answer) => {
            answer.isSelected = null;
          });
        });
      });
    },
    getQuestionFromSection(questionId) {
      let section = this.questions.find((a) =>
        a.questions.some((q) => q.id == questionId)
      );
      return section.questions.find((q) => q.id == questionId);
    },
    hasAnsweredInSection(sectionId, answerdId) {
      let section = this.questions.find((a) => a.id == sectionId);

      let hasAnswered = section.questions.some((q) =>
        q.answers.some((a) => a.id == answerdId && a.isSelected)
      );

      return hasAnswered;
    },
    hasAllAnsweredInSection(sectionId, answerdId) {
      let section = this.questions.find((a) => a.id == sectionId);

      let hasAnswered = section.questions.every((q) =>
        q.answers.some((a) => a.id == answerdId && a.isSelected)
      );

      return hasAnswered;
    },
    isQuestionAnswered(questionId) {
      let element = this.$refs['question_' + questionId];
      if (element != null && element.length > 0) {
        if (element[0].selectedAnswer != null) return true;
      }

      return false;
    },
    isVisibleSection(number, sectionList) {
      return this.sectionIndex >= number && sectionList.length > 0;
    },
    getSeccionQuestions(index) {
      if (this.questions[index] == null) return [];
      return this.questions[index].questions;
    },
    async onTransportTypeChange(selectedType) {
      this.localTransportType = selectedType;
      await this.getTransportTypeInfo();
      this.$emit('onTransportTypeChange', selectedType);
    },
    async getAcademicYear() {
      const response = await this.$ApiGet(
        `api/pei/getpeiyear?peiId=${store.getters.SelectedPei}`
      );
      this.peiYear = response.data;
    },
    async onSaveClick() {
      await this.SaveTransportQuestionnarie();
    },
    onEditClick() {
      this.$emit('on-edit');
    },
    validateQuestion207() {
      let question = this.getQuestionFromSection(207);

      let question208 = this.$refs['question_208'][0];

      if (question.answers.some((a) => a.id == 1 && a.isSelected)) {
        this.$nextTick(function() {
          this.$set(question208, 'isVisible', true);
        });
      } else {
        this.$nextTick(function() {
          this.$set(question208, 'isVisible', false);
        });
      }
    },
    async setSelectedAnswer(item) {
      let question = this.getQuestionFromSection(item.number);

      if (item.selectedAnswer) {
        question.answers[0].isSelected = true;
        question.answers[1].isSelected = false;
      } else if (item.selectedAnswer != null) {
        question.answers[0].isSelected = false;
        question.answers[1].isSelected = true;
      } else {
        question.answers[0].isSelected = false;
        question.answers[1].isSelected = false;
      }

      if (item.number == 207) {
        this.validateQuestion207();
      }
    },
    async SaveTransportQuestionnarie(showSuccess = true) {
      let answerQuestions1 = [];
      let answerQuestions2 = [];
      let answerQuestions3 = [];
      let answerQuestions4 = [];

      for (let question of this.seccion1) {
        for (let answer of question.answers) {
          if (answer.isSelected) {
            answerQuestions1.push({
              QuestionId: question.id,
              AnswerId: answer.id,
            });
          }
        }
      }

      if (this.sectionIndex >= 2) {
        for (let question of this.seccion2) {
          for (let answer of question.answers) {
            if (answer.isSelected) {
              answerQuestions2.push({
                QuestionId: question.id,
                AnswerId: answer.id,
              });
            }
          }
        }
      }

      if (this.sectionIndex >= 3) {
        for (let question of this.seccion3) {
          for (let answer of question.answers) {
            if (answer.isSelected) {
              answerQuestions3.push({
                QuestionId: question.id,
                AnswerId: answer.id,
              });
            }
          }
        }
      }

      if (this.sectionIndex >= 4) {
        for (let question of this.seccion4) {
          for (let answer of question.answers) {
            if (answer.isSelected) {
              answerQuestions4.push({
                QuestionId: question.id,
                AnswerId: answer.id,
              });
            }
          }
        }
      }

      let response = await this.$ApiPost(
        `api/pei/selectanswertransportrequest`,
        {
          QuestionaryId: this.questionaryId,
          QuestionsAnswersSeccion1List: answerQuestions1,
          QuestionsAnswersSeccion2List: answerQuestions2,
          QuestionsAnswersSeccion3List: answerQuestions3,
          QuestionsAnswersSeccion4List: answerQuestions4,
          IsEducativeService: this.isEducativeService,
          isTherapyService: this.isTherapyService,
        }
      );
      if (response.status == '200') {
        showSuccess &&
          alert.methods.ShowToast(
            'Atencion',
            'Respuestas escogidas exitosamente',
            'success'
          );
        this.$emit('on-update');
      }
    },
    setQuestionData() {
      this.currentSections.forEach((section) => {
        section.questions.forEach((question) => {
          let questionRef = `question_${question.id}`;
          let questionElement = this.$refs[questionRef];
          question.answers.forEach((answer) => {
            if (answer.isSelected) {
              questionElement[0].selectedAnswer = answer.id == 1;
            }
          });
        });
      });
    },
    async getTransportTypeInfo() {
      //1. No required, 2. Regular, 3.Carrier, 4.Scholarship

      if (this.localTransportType == transportTypes.REGULAR) {
        //2
        let responseDeparture = await this.$ApiGet(
          `api/pei/getservidedepartureCode`
        );
        this.departureList = responseDeparture.data;
        this.placeList = responseDeparture.data;
      }
      if (this.localTransportType == transportTypes.PORTEADOR) {
        //3
        let responseDeparture = await this.$ApiGet(
          `api/pei/getservidedepartureCode`
        );
        let responseSpecialEquipment = await this.$ApiGet(
          `api/pei/getspecialequipment`
        );

        this.departureList = responseDeparture.data;
        this.placeList = responseDeparture.data;
        this.specialEquipment = responseSpecialEquipment.data;
      }
      if (this.localTransportType == transportTypes.BECA) {
        //4
        let responseDeparture = await this.$ApiGet(
          `api/pei/getservidedepartureCode`
        );
        let responseSpecialEquipment = await this.$ApiGet(
          `api/pei/getspecialequipment`
        );

        this.departureList = responseDeparture.data;
        this.placeList = responseDeparture.data;
        this.specialEquipment = responseSpecialEquipment.data;
      }

      await this.$ApiGet('/api/schools/municipalities').then((res) => {
        this.municipalityList = res.data;
      });
    },
  },
  components: {
    ServiceStatusBadge,
    Accordion,
    AccordionItem,
    WizardQuestion,
    ServiceWarningBox,
    TransportNoDefined,
    TransportRegular,
    TransportCarrier,
    TransportScholarship,
  },
  async mounted() {
    this.setQuestionData();
    if (this.isAllAnsweredNo) {
      this.localTransportType = '-1';
    } else {
      this.localTransportType = this.transportType;
    }

    await this.getTransportTypeInfo();
    await this.getAcademicYear();
  },
};
</script>

<style scoped>
.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.box-white {
  background: #fff;
  margin: 0px;
  padding: 20px;
}

.box-white-title {
  margin-bottom: 10px;
}

.accordion-box {
  padding: 0px;
  margin: 0px;
}

.accordion {
  margin-top: 0px !important;
}

.accordion >>> .question-element {
  margin-top: -9px !important;
}

.accordion >>> .item-pane {
  border-bottom: none !important;
  margin-top: 9px !important;
  box-shadow: 0px 1px 1px #e2e2e2 !important;
  border: 1px solid #e2e2e2;
}
</style>
